import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const useGenerateReport = () => {
  const {t} = useTranslation()

  const {data, isPending, mutateAsync} = useMutation({
    mutationFn: mutations.generateReport,
    onError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useGenerateReport')
        .extras({errorDetails})
        .error('Error occurred while generating report')

      spawnErrorToast(t('error.generateReport'))
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.generateReport'))
    }
  })

  return {report: data, isFetching: isPending, generateReport: mutateAsync}
}
